// 閘道（NVR / Station）的通道設定（ONVIF 納管、Kinio 攝影機通道）誰能做：跟平台 onvifScope 同一條——
// 家戶 owner / admin（can_manage），或企業組織的家戶由 owner / org_admin / 有 org.sites 的成員設（cmd/app-api/onvif.go、vmsmaps.go floorplanScope）。
import { canManage, type VmsDevice } from '../../lib/devices';
import { hasOrgPerm, orgUsable, type MyOrg, type ScopeHome } from '../../lib/planeApi';

type HomeLite = Pick<ScopeHome, 'home_id' | 'org_id' | 'org_kind'>;
type OrgLite = Pick<MyOrg, 'org_id' | 'kind' | 'role' | 'org_permissions' | 'notice'>;

/** 這個企業組織我能不能設它家戶的閘道通道（owner / org_admin / org.sites，且組織路徑沒被擋）。 */
export function orgSitesOrg(o: OrgLite | undefined): boolean {
  return !!o && o.kind === 'team' && orgUsable(o) && hasOrgPerm(o, 'org.sites');
}

export function canSetChannels(d: VmsDevice, homes: HomeLite[], orgs: OrgLite[]): boolean {
  if (canManage(d)) return true;
  const h = homes.find((x) => x.home_id === d.homeId);
  if (!h || h.org_kind !== 'team' || !h.org_id) return false;
  return orgSitesOrg(orgs.find((o) => o.org_id === h.org_id));
}
